import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useUserContext } from '../../UserContext';

export const ProtectedRoute = ({ children, rolesAllowed }) => {
  const { user, setEmail } = useUserContext();
  const [hydrated, setHydrated] = useState(false);
  const [shouldRedirect, setShouldRedirect] = useState(false);
  const [isBot, setIsBot] = useState(false);

  useEffect(() => {
    setHydrated(true);

    if (typeof navigator !== 'undefined') {
      const ua = navigator.userAgent;
      const isReactSnap = /ReactSnap/.test(ua);
      const isCrawler = /bot|crawl|spider|slurp|duckduckgo|PhantomJS/i.test(ua);
      const botDetected = isReactSnap || isCrawler;

      setIsBot(botDetected);
    }
  }, []);

  useEffect(() => {
    if (hydrated && !isBot) {
      if (!user) {
        setEmail?.();
        setShouldRedirect(true);
      } else if (rolesAllowed && !rolesAllowed.includes(user?.role)) {
        setShouldRedirect(true);
      }
    }
  }, [hydrated, isBot, user, rolesAllowed, setEmail]);

  // 🛑 Skip rendering for ReactSnap or bots
  if (typeof navigator !== 'undefined' && /ReactSnap/.test(navigator.userAgent)) {
    return null;
  }

  if (!hydrated || isBot) {
    return null; // Optionally show <Spinner /> instead
  }

  if (shouldRedirect) {
    return <Navigate to="/" replace />;
  }

  return children;
};

